import _ from 'lodash'
import store from '@/store'
import router from '@/router'
import { MES_PORTAL_URL, PORTAL_URL } from "@/config";
import { postToUserServer, getLocalStorge } from './common';

/**
 * 从本地存储初始化登陆信息
 */
export async function initAccount(token) {
  let user;
  if (token) {
    user = await loginByToken(token);
    if (user) user.token = token;
    await store.dispatch('setLogedUser', user);
  } else {
    user = await getLocalStorge('logedUser');
    store.commit('setLogedUser', user);
  }
  console.log("curUser", user);
}

// 公共分类
export async function getMergeDict(obj) {
  return await postToUserServer('/merge-dict', obj);
}

/**
 * 修改个人信息
 */
export async function modConfig(obj) {
  obj.user_id = store.state.loginUser.user.id;
  await modUserInfo(obj);
  let logedUser = await getLocalStorge('logedUser');
  let getLogedUser = await getLogedUserInfo();
  Object.assign(logedUser.user, getLogedUser);
  await store.dispatch('setLogedUser', logedUser);
}

/**
 * 修改指定用户信息
 * @param {*} obj 
 */
export async function modUserInfo(obj) {
  return await postToUserServer('/my-company/set-userinfo', obj);
}

/**
 * 发起个人认证
 * @param {*} obj 
 */
export async function userVerify(obj) {
  return await postToUserServer('/user/verify-person-info', obj);
}

/**
 * 修改手机号码
 */
export async function modMp(number, smsCode) {
  let obj = {
    user_id: store.state.loginUser.user.id,
    mobile: number,
    code: smsCode
  }
  await postToUserServer('/my-company/set-mobile', obj);
}

/**
 * 修改密码
 * @param {*} old_password 
 * @param {*} password 
 * @param {*} cpassword 
 */
export async function modPwd(old_password, password, cpassword) {
  let obj = {
    user_id: store.state.loginUser.user.id,
    old_passwd: old_password,
    new_passwd: password,
    new_passwd_confirmed: cpassword
  }
  await postToUserServer('/my-company/set-password', obj);
}

/**
 * 修改密码-验证旧密码是否正确
 */
export async function modPwdAgo(old_password) {
  await postToUserServer('/my-company/verify-my-password', { passwd: old_password });
}

/**
 * 清除登陆信息,回到首页
 */
export async function logOut() {
  await store.dispatch('setLogedUser', null);
  localStorage.removeItem('business_token');
  router.push('/home');
  if (process.env.VUE_APP_TITLE !== 'development') {
    location.href = MES_PORTAL_URL + "?p_token=clear";
  }
}

/**
 * mes门户到中台登录跳转回mes门户自动清除中台登录信息
 */
export async function quit() {
  await store.dispatch('setLogedUser', null);
  localStorage.removeItem('business_token');
}

/**
 * 使用手机号+邀请码注册
 * @param {*} _obj 
 */
export async function createMobileAccountByInvite(_obj) {
  let resp = await postToUserServer('/register-by-invite/reg', _obj);
  let logedUser = Object.assign({}, store.state.loginUser, {
    user: resp.user,
    token: resp.token,
    comp: resp.comp
  });
  localStorage.setItem('business_token', resp.token);
  await store.dispatch('setLogedUser', logedUser);
}

/**
 * 注册时（验证邀请码）
 */
export async function verifyInviteCode(obj) {
  await postToUserServer('/register-by-invite/auth-invite-code', obj);
}

/**
 * 创建手机用户账号,并设置登陆态
 * @param {*} _obj 注册请求参数 
 */
export async function createMobileAccount(_obj) {
  let resp = await postToUserServer('/register-by-mobile/reg', _obj);
  let user = Object.assign({}, store.state.loginUser, {
    user: resp.user,
    token: resp.token,
    refresh_token: resp.refresh_token,
    comp: resp.comp
  });
  localStorage.setItem('business_token', resp.token);
  await store.dispatch('setLogedUser', user);
}

/**
 * 查询手机号是否已经注册
 */
export async function createMobileAccountAgo(_obj) {
  return await postToUserServer('/login/is-mobile-reg', _obj);
}

/**
 * 获得当前登陆用户信息
 */
export async function getLogedUserInfo() {
  let userInfo = await postToUserServer('/my-company/get-myinfo', {});
  return userInfo;
}

/**
 * 手机号+密码登陆
 * @param {*} _obj 
 */
export async function loginByMobileAndPwd(_obj) {
  let resp = await postToUserServer('/login-by-account/auth', {
    mobile: _obj.mobile,
    passwd: _obj.passwd,
    captcha: _obj.captcha,
    captcha_token: _obj.captchaToken,
    remember: _obj.remember,
  });
  let user = {
    user: resp.user,
    token: resp.token,
    refresh_token: resp.refresh_token,
    comp: resp.comp
  };
  await store.dispatch('setLogedUser', user);
  return resp
}

/**
 * 使用手机号登陆,并设置登陆态
 * @param {*} _obj 注册请求参数 
 * @param {*} _this vue实例
 */
export async function loginByMobile(_obj, _this) {
  let resp = await postToUserServer('/login-by-mobile/auth', {
    mobile: _obj.mobile,
    code: _obj.code,
    captcha: _obj.captcha,
    captcha_token: _obj.captcha_token,
    remember: _obj.remember
  });
  let user = {
    user: resp.user,
    token: resp.token,
    refresh_token: resp.refresh_token,
    comp: resp.comp
  };
  localStorage.setItem('business_token', resp.token);
  await store.dispatch('setLogedUser', user);
}

/**
 * 根据token登录
 * @param {*} token 
 */
export async function loginByToken(token) {
  let resp = await postToUserServer('/login-by-token/auth', { token });
  return {
    user: resp.user,
    comp: resp.comp
  };
}

/**
 * 手机号重置密码+登录
 * @param {*} token 
 */
export async function findPasswordReset(obj) {
  let resp = await postToUserServer('/find-password/reset', obj);
  let user = {
    user: resp.user,
    token: resp.token,
    refresh_token: resp.refresh_token,
    comp: resp.comp
  };
  localStorage.setItem('business_token', resp.token);
  await store.dispatch('setLogedUser', user);
}

/**
 * 获取邀请码
 */
export async function genInviteCode() {
  return await postToUserServer('/my-company/create-invite-code');
}

/**
 * 发送邀请码
 */
export async function sendInviteCode(invite_code, phones) {
  return await postToUserServer('/my-company/send-invite', {
    invite_code: invite_code,
    mobiles: phones
  });
}

/**
 * 查询多个用户信息
 */
export async function getUserInfoByIds(comp_id, user_ids = []) {
  let users = await postToUserServer('/my-company/get-multi-userinfo', {
    comp_id: comp_id,
    user_ids: user_ids.join()
  });
  return Object.values(users);
}

/**
 * 查询企业可用角色列表
 */
export async function getRolesByCompId(obj) {
  return await postToUserServer('/my-company/get-roles', obj);
}

/**
 * 搜索企业可用角色列表
 */
export async function getRolesSearchMember(obj) {
  let res = await postToUserServer('/my-company/search-member', obj);
  return res;
}

/**
 * 获取角色详情
 */
export async function getRoleInfo(compId, roleId) {
  let role = await postToUserServer('/my-company/get-role', {
    comp_id: compId,
    role_id: roleId
  });
  if (role.privs) role.privs = Object.values(role.privs);
  return role;
}

/**
 * 获得企业可分配的权限列表
 */
export async function getPrivisByCompId(compId) {
  return await postToUserServer('/my-company/get-priv-struct', {
    comp_id: compId
  });
}

/**
 * 保存角色
 */
export async function saveRole(obj) {
  if (obj.role_id) {
    return await postToUserServer('/my-company/set-role', obj);
  } else {
    return await postToUserServer('/my-company/add-role', obj);
  }
}

/**
 * 删除角色
 */
export async function delRole(compId, roleId) {
  return await postToUserServer('/my-company/delete-role', {
    comp_id: compId,
    role_id: roleId
  });
}

/**
 * 批量设置人员所属部门
 */
export async function setMembersDept(comp_id, user_ids, dept_ids) {
  return await postToUserServer('/my-company/set-members-dept', {
    comp_id: comp_id,
    user_ids: user_ids.join(),
    dept_ids: dept_ids.join()
  });
}

/**
 * 从该企业批量移除⽤户成员
 */
export async function delUserByIds(comp_id, user_ids) {
  return await postToUserServer('/my-company/remove-members', {
    comp_id: comp_id,
    user_ids: user_ids.join()
  });
}

// 省可信身份认证相关API
/**
 * code换token（规范2.2）
 */
export async function getProvinceToken(code) {
  return await postToUserServer('/auth/getProvinceToken', { code });
}

/**
 * 获取用户主体信息（规范3.1）
 */
export async function getUserMainInfo(access_token) {
  return await postToUserServer('/auth/getUserMainInfo', { access_token }, 'GET');
}

/**
 * 获取个人用户详细信息（规范3.2）
 */
export async function getPersonUserDetail() {
  return await postToUserServer('/auth/getPersonUserDetail', {});
}

/**
 * 获取法人用户详细信息（规范3.3）
 */
export async function getCorpUserDetail() {
  return await postToUserServer('/auth/getCorpUserDetail', {});
}

/**
 * 账号绑定（省平台→业务系统，规范1.1.3.2.3）
 */
export async function bindAccount(obj) {
  return await postToUserServer('/auth/bindAccount', obj);
}

/**
 * 信任传递接口（规范3.5）
 */
export async function trustPass(code) {
  return await postToUserServer('/auth/trustPass', { code });
}

/**
 * 省平台注销（规范3.6）
 */
export async function logoutProvince(user_id) {
  return await postToUserServer('/auth/logoutProvince', { user_id });
}